import { styled } from '@mui/material/styles';

export interface StyledWrapperProps {
  active?: boolean;
  isBadge?: boolean;
  isFirstProduct?: boolean;
  isShownProductType?: boolean;
}

export const StyledWrapper = styled('div')<StyledWrapperProps>(
  ({ theme, active, isBadge, isFirstProduct, isShownProductType }) => {
    return {
      position: 'relative',
      padding: 0,
      transition: 'padding 0.3s ease',

      ...((!isFirstProduct || (isFirstProduct && isShownProductType)) && {
        marginTop: isBadge ? '32px' : '16px',
      }),

      ...(active && {
        border: `2px solid ${theme.palette.neutral[200]}`,
        borderRadius: 'var(--payment-products-wrapper-border-radius)',
        padding: '16px',
        [theme.breakpoints.up('md')]: {
          padding: '24px',
        },
      }),
    };
  },
);

export interface StyledBadgeWrapperProps {
  active?: boolean;
}

export const StyledBadgeWrapper = styled('div')<StyledBadgeWrapperProps>(
  ({ active }) => {
    return {
      position: 'absolute',
      top: active ? '-24px' : '-22px',
      left: active ? '-2px' : 0,
    };
  },
);
